document.addEventListener('click', function(e){
 const open=e.target.closest('[data-open-panel]'); if(open){const p=document.querySelector(open.dataset.openPanel);if(p){p.classList.add('is-open');p.setAttribute('aria-hidden','false');}}
 const close=e.target.closest('[data-close-panel]'); if(close){const p=close.closest('.side-panel');if(p){p.classList.remove('is-open');p.setAttribute('aria-hidden','true');}}
 const play=e.target.closest('[data-video-toggle]'); if(play){const v=document.getElementById(play.dataset.videoToggle);if(v){if(v.paused){v.play();play.textContent='Pause video';}else{v.pause();play.textContent='Play video';}}}
 const gab=e.target.closest('a[href="#gabby"]'); if(gab){e.preventDefault();setGabby(true);const gi=document.getElementById('GabbyInput');if(gi)gi.focus();}
 if(e.target.closest('[data-gabby-toggle]')){const w=document.getElementById('GabbyWidget');setGabby(w&&w.hidden);}
 if(e.target.closest('[data-gabby-close]')){setGabby(false);}
 if(e.target.closest('[data-gabby-find]')){const s=document.getElementById('HeaderSearch');if(s){window.scrollTo({top:0,behavior:'smooth'});s.focus();}}
});

// Gabby chat widget: open by default on wide screens unless the shopper closed it before.
function setGabby(open){
 const w=document.getElementById('GabbyWidget'), b=document.querySelector('[data-gabby-toggle]'); if(!w)return;
 w.hidden=!open; document.body.classList.toggle('gabby-open',open); if(b)b.setAttribute('aria-expanded',String(open));
 try{localStorage.setItem('apexGabby',open?'open':'closed');}catch(err){}
}
document.addEventListener('DOMContentLoaded',function(){
 let saved=null; try{saved=localStorage.getItem('apexGabby');}catch(err){}
 const w=document.getElementById('GabbyWidget'); if(!w)return;
 const open=saved?saved==='open':window.matchMedia('(min-width: 1200px)').matches;
 w.hidden=!open; document.body.classList.toggle('gabby-open',open);
});

// Gabby replies come from the APEX endpoint; if it is down, the question becomes a store search.
document.addEventListener('submit',async function(e){
 const form=e.target.closest('[data-gabby-form]'); if(!form)return; e.preventDefault();
 const input=form.querySelector('input[name="message"]'), log=document.querySelector('[data-gabby-log]'); const message=input.value.trim(); if(!message)return;
 log.insertAdjacentHTML('beforeend','<p class="gabby-msg gabby-msg--me">'+escapeText(message)+'</p>');input.value='';log.scrollTop=log.scrollHeight;
 try{
  const r=await fetch('https://agentic.apexlifeglobal.com/api/gabby',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({mode:'store',messages:[{role:'user',content:message}]})});
  const data=await r.json().catch(()=>({}));
  const reply=data.reply||data.message;
  if(!r.ok||!reply)throw new Error('unavailable');
  log.insertAdjacentHTML('beforeend','<p class="gabby-msg">'+escapeText(reply)+'</p>');
 }catch(err){
  log.insertAdjacentHTML('beforeend','<p class="gabby-msg">Let me pull that up in the store for you…</p>');
  setTimeout(function(){window.location.href='/search?type=product&q='+encodeURIComponent(message);},900);
 }
 log.scrollTop=log.scrollHeight;
});
function escapeText(s){return String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));}
